import { render, staticRenderFns } from "./UploadItem.vue?vue&type=template&id=0d9e8476&"
import script from "./UploadItem.vue?vue&type=script&lang=js&"
export * from "./UploadItem.vue?vue&type=script&lang=js&"
import style0 from "./UploadItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports